module.exports = __webpack_public_path__ + "static/media/menu.f8b55770.svg";